<template>
  <div
    v-if="isLoading"
    class="row fit window-height justify-center items-center"
  >
    <q-spinner
      color="primary"
      size="6rem"
      :trickness="4"
    />
  </div>
</template>

<script>
export default {
  name: 'LoaderWrapper',
  data: () => ({
    isLoading: false,
  }),
  created() {
    this.$g.loading.on(this.handleLoadingEvent);
  },
  destroyed() {
    this.$g.loading.off(this.handleLoadingEvent);
  },
  methods: {
    handleLoadingEvent(action) {
      const types = {
        SHOW: () => {
          this.isLoading = true;
        },
        HIDE: () => {
          this.isLoading = false;
        },
      };

      return types[action.type] && types[action.type]();
    },
  },
};
</script>
